<template lang="pug">
  v-dialog(:value="open", width="363", persistent).lock-attempts-modal
    v-card(style="border-radius: 5px;")
      v-card-text
        v-layout(align-center justify-center column fill-height)
          v-flex(style="margin-top: 1.5em;height: 150px;")
            v-img
              img(:src="oopsIcon" :style="{height: '150px', width: '150px'}")
          v-flex(style="margin:1em;text-align: center;")
            span.omnesMedium(style="font-size: 18px;color: #0855C4;") ¡No fue posible continuar con el acceso!
          v-flex.lock-attempts-message(style="text-align: center;width: 22em;")
            span(style="font-size: 16px;line-height: initial;color: #535D66;" v-html="lockMessage")
          v-flex.lock-attempts-buttons(style="margin-top: 2.5em;margin-bottom: 1em;")
            v-layout(row justify-center)
              v-btn.lock-attempts-btn-primary(@click="$emit('go-to-register')")
                span.omnesSemibold Registrarme
              v-btn.lock-attempts-btn-secondary(@click="$emit('go-to-recovery')")
                span.omnesRegular Olvidé mi contraseña
</template>

<script>
/**
 * @component LockAttemptsModal
 * @description Modal para el bloqueo por intentos fallidos (tipoBloqueo = BLOQUEO_INTENTOS).
 * Ofrece al usuario dos salidas: registrarse o recuperar contraseña.
 * @example
 * LockAttemptsModal(
 *   :open="lockInfo.showCountdown && lockInfo.lockType === 'BLOQUEO_INTENTOS'"
 *   :lockMessage="lockMessage"
 *   @go-to-register="goToRegister"
 *   @go-to-recovery="goToRecoveryPassword"
 * )
 */
export default {
  name: 'LockAttemptsModal',
  props: {
    /** Controla la visibilidad del modal */
    open: {
      type: Boolean,
      required: true
    },
    /** Mensaje HTML con el detalle del bloqueo (puede contener negritas vía <strong>) */
    lockMessage: {
      type: String,
      default: ''
    }
  },
  computed: {
    oopsIcon () {
      return require('@/assets/characters/oops.svg')
    }
  }
}
</script>

<style scoped>
.lock-attempts-message {
  text-align: center;
  width: 22em;
}
.lock-attempts-btn-primary {
  background: #FFFFFF !important;
  border: 1px solid #EA0D90 !important;
  border-radius: 4px !important;
  width: 152px !important;
  height: 45px !important;
  margin-right: 10px !important;
  box-shadow: none !important;
}
.lock-attempts-btn-primary span {
  text-transform: initial !important;
  font-size: 15px !important;
  color: #EA0D90 !important;
}
.lock-attempts-btn-secondary {
  background: #EA0D90 !important;
  border-radius: 4px !important;
  width: 152px !important;
  height: 45px !important;
  box-shadow: none !important;
}
.lock-attempts-btn-secondary span {
  text-transform: initial !important;
  font-size: 15px !important;
  color: #FFFFFF !important;
}

@media only screen and (max-width: 600px) {
  .lock-attempts-modal >>> .v-dialog {
    max-width: 90% !important;
    width: 90% !important;
  }
  .lock-attempts-message {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 1em;
  }
  .lock-attempts-buttons {
    width: 100%;
    padding: 0 0.5em;
  }
  .lock-attempts-btn-primary,
  .lock-attempts-btn-secondary {
    width: 140px !important;
    height: 45px !important;
    margin-right: 8px !important;
  }
  .lock-attempts-btn-primary span,
  .lock-attempts-btn-secondary span {
    font-size: 14px !important;
  }
}

@media only screen and (max-width: 375px) {
  .lock-attempts-modal >>> .v-dialog {
    max-width: 95% !important;
    width: 95% !important;
  }
  .lock-attempts-message {
    padding: 0 0.5em;
  }
  .lock-attempts-message span {
    font-size: 14px !important;
  }
  .lock-attempts-buttons {
    margin-top: 1.5em !important;
    margin-bottom: 0.5em !important;
    padding: 0;
  }
  .lock-attempts-btn-primary,
  .lock-attempts-btn-secondary {
    width: 140px !important;
    height: 45px !important;
    margin-right: 6px !important;
  }
  .lock-attempts-btn-primary span,
  .lock-attempts-btn-secondary span {
    font-size: 15px !important;
  }
}

@media only screen and (max-width: 325px) {
  .lock-attempts-modal >>> .v-dialog {
    max-width: 95% !important;
    width: 95% !important;
  }
  .lock-attempts-message {
    padding: 0 0.5em;
  }
  .lock-attempts-message span {
    font-size: 13px !important;
    line-height: 1.5 !important;
  }
  .lock-attempts-buttons {
    margin-top: 1.5em !important;
    margin-bottom: 0.5em !important;
    padding: 0;
  }
  .lock-attempts-btn-primary,
  .lock-attempts-btn-secondary {
    width: 120px !important;
    height: 36px !important;
    margin-right: 6px !important;
  }
  .lock-attempts-btn-primary span,
  .lock-attempts-btn-secondary span {
    font-size: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/LockAttemptsModal.vue